import { createPartyRequest } from './helper';
export const postPartyNotesBff = createPartyRequest({
    route: '/party/parties/:partyNo/notes',
    method: 'post',
    source: 'app',
});
